import {
  EditBlockColorPicker,
  EditBlockSelect,
  EditBlockTextInput,
  EditBlockNumericInput,
  EditBlockSliderInput,
  EditBlockSwitch,
} from '@components/EditBuildingBlocks/all'
import genericContentItemEditor from '@components/mixins/genericContentItemEditor'
import { mapGetters } from 'vuex'

export default {
  name: 'VoucherEditorComponent',
  mixins: [genericContentItemEditor],
  components: {
    'edit-block-color-picker': EditBlockColorPicker,
    'edit-block-select': EditBlockSelect,
    'edit-block-text-input': EditBlockTextInput,
    'edit-block-numeric-input': EditBlockNumericInput,
    'edit-block-slider-input': EditBlockSliderInput,
    'edit-block-switch': EditBlockSwitch,
  },
  data() {
    return {}
  },
  computed: {
    ...mapGetters('campaign/widget', ['targetWidgetType']),
    voucherText: {
      get() {
        return this.targetWidgetType === 'fortuneWheel'
          ? 'Fortune Wheel Voucher'
          : this.component.content.text
      },
      set(value) {
        this.updateContentItem({
          id: this.component.id,
          path: ['content'],
          attribute: ['text'],
          data: value,
        })
      },
    },
    voucherFontFamily: {
      get() {
        return this.component.styling.fontFamily
      },
      set(value) {
        this.updateContentItem({
          id: this.component.id,
          path: ['styling'],
          attribute: ['fontFamily'],
          data: value,
        })
      },
    },
    voucherFontColor: {
      get() {
        return this.component.styling.color
      },
      set(value) {
        this.updateContentItem({
          id: this.component.id,
          path: ['styling'],
          attribute: ['color'],
          data: value,
        })
      },
    },
    voucherFontSize: {
      get() {
        return this.component.styling.fontSize
      },
      set(value) {
        this.updateContentItem({
          id: this.component.id,
          path: ['styling'],
          attribute: ['fontSize'],
          data: value,
        })
      },
    },
    voucherFontWeight: {
      get() {
        return this.component.styling.fontWeight === 'bold'
      },
      set(value) {
        const fontWeight = value ? 'bold' : 'normal'

        this.updateContentItem({
          id: this.component.id,
          path: ['styling'],
          attribute: ['fontWeight'],
          data: fontWeight,
        })
      },
    },
    voucherBorderWidth: {
      get() {
        // Removes 'px' from string
        return parseInt(this.component.styling.borderWidth, 10)
      },
      set(value) {
        this.updateContentItem({
          id: this.component.id,
          path: ['styling'],
          attribute: ['borderWidth'],
          data: value + 'px',
        })
      },
    },
    voucherBorderRadius: {
      get() {
        return parseInt(this.component.styling.borderRadius, 10)
      },
      set(value) {
        this.updateContentItem({
          id: this.component.id,
          path: ['styling'],
          attribute: ['borderRadius'],
          data: value + 'px',
        })
      },
    },
    voucherBorderColor: {
      get() {
        return this.component.styling.borderColor
      },
      set(value) {
        this.updateContentItem({
          id: this.component.id,
          path: ['styling'],
          attribute: ['borderColor'],
          data: value,
        })
      },
    },
    voucherTextAlign: {
      get() {
        return this.component.styling.textAlign
      },
      set(value) {
        this.updateContentItem({
          id: this.component.id,
          path: ['styling'],
          attribute: ['textAlign'],
          data: value,
        })
      },
    },
  },
}
